import { render, staticRenderFns } from "./DeprecationBanner.vue?vue&type=template&id=6b48775e&scoped=true&"
import script from "./DeprecationBanner.vue?vue&type=script&lang=js&"
export * from "./DeprecationBanner.vue?vue&type=script&lang=js&"
import style0 from "./DeprecationBanner.vue?vue&type=style&index=0&id=6b48775e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b48775e",
  null
  
)

export default component.exports